import React from 'react'
import { css } from '@emotion/react'
import { useLocation } from 'react-router-dom'

const VideoPage = () => {
  const location = useLocation()
  const { src: videoSrc } = location.state
  return (
    <div css={videoPageStyle}>
      <video
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        controls
        className="videopage_video"
      ></video>
    </div>
  )
}
const videoPageStyle = css`
  height: 100vh;
  position: relative;
  background: #fff;
  overflow-x: hidden;
  .videopage_video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
  }
`

export default VideoPage
